import {useAntdTable as useFormTable, useRequest} from "ahooks";
import request from "../utils/request";
import {Method} from "axios";
import {Form} from "antd";
import {useState} from "react";
import {AntdTableOptions} from "ahooks/lib/useAntdTable/types";

interface Options extends AntdTableOptions<any, any> {
    method?: Method,
    selectTable?: boolean | string
    downloadUrl?:string
}

function useAntTable(url: string | undefined, options: Options) {

    const {method = 'get', selectTable = false, downloadUrl} = options

    function service({current, pageSize, sorter}: any, formData: any) {
        formData = {...options.defaultParams||{},...form.getFieldsValue()}
        if (url) {
            setQueryParams(formData)
            const requestParamsKeys = Object.keys(formData).filter(i => formData[i] !== null && formData[i] !== undefined)
            const requestParams: { [key: string]: any } = {}
            requestParamsKeys.forEach(i => {
                if(typeof formData[i]=='string' && formData[i]==''){
                    requestParams[i] = undefined;
                }else{
                    requestParams[i] = formData[i];
                }
            })
            return request.request<BaseResponse<any>>({
                url: url,
                method: method,
                [method === 'get' ? 'params' : 'data']: {
                    page: current,
                    limit: pageSize,
                    ...requestParams
                }
            }).then(data => {
                setSelectedRows([]);
                setSelectedRowKeys([]);
                return {
                    list: data.data.data,
                    total: data.data.total,

                }
            })
        } else {
            return Promise.resolve()
        }
    }


    async function onDownload(param:any={}) {
        if (!downloadUrl) return undefined
        const urlSearchParams = new URLSearchParams();
        Object.keys(param).forEach(k=>{
            urlSearchParams.append(k,param[k]);
        });
        const paramArr = Object.keys(queryParams||{}).map(k=>(queryParams[k]==null||queryParams[k]==undefined)?{}:{[k]:queryParams[k]});
        const params = paramArr.reduce((a={},b={})=>({...a,...b}),{});
        return request.request({
            url: Object.keys(param).length?`${downloadUrl}?${urlSearchParams.toString()}`:downloadUrl,
            method: method,
            responseType: 'blob',
            [method === 'get' ? 'params' : 'data']: {
                ...params,
                selected: selectedRowKeys.length > 0 ? (method === 'get' ? selectedRowKeys.join(',') : selectedRowKeys) : null
            },
        }).then(response => {
            const fileName = (response.headers['Content-Disposition'] || response.headers['content-disposition']).split("''")[1]
            const link = document.createElement('a')
            link.href = URL.createObjectURL(response.data)
            link.download = decodeURIComponent(fileName)
            link.style.display = 'none'
            document.body.appendChild(link)
            link.click()
            link.remove()
        })
    }

    const [form] = Form.useForm()
    const {runAsync: download, loading: downloading} = useRequest(onDownload, {manual: true})
    const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([])
    const [selectedRows, setSelectedRows] = useState<any[]>([])
    const [queryParams, setQueryParams] = useState<any>({})
    // const [editingKey, setEditingKey] = useState()
    // const [editRecord, setEditRecord] = useState<any>()


    function onSelectedChange(keys: any[], rows: any[]) {
        setSelectedRowKeys(keys)
        setSelectedRows(rows)
    }

    const {tableProps: tp, search, pagination, ...others} = useFormTable(service, {...options, form})
    const showQuickJumper = true
    const showSizeChanger = true
    const rowSelection: any = {
        type: typeof selectTable === "string" ? selectTable : null,
        fixed: true,
        selectedRowKeys,
        selectedRows,
        onChange: onSelectedChange,
    }

    const tableProps = {
        ...tp,
        pagination: {
            ...pagination,
            showQuickJumper,
            showSizeChanger,
        },
        submit: search.submit,
        rowSelection: selectTable ? rowSelection : undefined
        // form: form,
    }
    return {
        tableProps,
        search,
        form,
        download,
        downloading,
        ...others
    }
}

export default useAntTable
